module.exports = __webpack_public_path__ + "img/two.868f3ac2.png";